var _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiAddonSunglasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 36h36V0H0v36Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.24-.239 1.437-.958 1.677-1.675.24-.717.72-5.307 2.158-6.505 1.484-1.232 7.077-.773 8.149-.24 2.397 1.195 2.691 5.055 3.115 6.745.239.957 1.677.957 1.677.957s1.439 0 1.678-.956c.424-1.691.72-5.562 3.115-6.755 1.073-.535 6.666-.994 8.152.238 1.435 1.197 1.915 5.799 2.155 6.517.238.717 1.437 1.435 1.677 1.674.241.239.241 1.196 0 1.436-.479.478-6.134.904-12.223.239-1.215-.133-1.677-.479-4.554-.479-2.875 0-3.339.346-4.553.478C6.136 2.34.479 1.914 0 1.436-.239 1.196-.239.239 0 0",
    style: {
      fill: "#292f33",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(1.24 20.982)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiAddonSunglasses);
export default __webpack_public_path__ + "static/media/emoji-addon-sunglasses.41ef6bc79144869f089d9dbc8d627849.svg";
export { ForwardRef as ReactComponent };